import { render, staticRenderFns } from "./ArriveeDeBebe.vue?vue&type=template&id=01b989ee&scoped=true&"
import script from "./ArriveeDeBebe.vue?vue&type=script&lang=ts&"
export * from "./ArriveeDeBebe.vue?vue&type=script&lang=ts&"
import style0 from "./ArriveeDeBebe.vue?vue&type=style&index=0&id=01b989ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b989ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
